import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import { TableCompHead } from '../../../../components/ui';
import { convToTime } from '../../../../utils/helpers';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';

interface IProps {
  moduleData: any;
  isView: boolean;
  tabValue: number;
  machineData?: any;
}

const THead = ({ tabValue, moduleData, isView, machineData }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={19}
        rowSpan={3}
        labels={['DOC. NO', 'REV. NO', 'REV. DATE.']}
        values={['FM-QAD-35', '05', '27/07/2023']}
        heading="FIRST  OFF APPROVAL"
      />
      <tr>
        <th colSpan={5} align="left">
          Date:
          {isView ? (
            formatDate(moduleData.setup_date)
          ) : (
            <DatePickerMui
              label="FPA Date"
              value={moment(moduleData.setup_date)}
              onChange={(date) => {
                moduleData.setup_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th colSpan={14}></th>
      </tr>
      <tr>
        <th align="left" colSpan={4}>
          PROCESS NAME : {moduleData?.setups?.[tabValue]?.process_name}
        </th>
        <th align="left" colSpan={6}>
          PROCESS NO.:{moduleData?.setups?.[tabValue]?.process_no}
        </th>
        <th align="left" colSpan={5}>
          DOC. NO:
        </th>
        <th align="left" colSpan={4}>
          TCS/FOA/007
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={4}>
          PART NAME :{' '}
          {moduleData.part_name
            ? moduleData.part_name
            : moduleData.part_id?.part_name}
        </th>
        <th align="left" colSpan={6}>
          CUSTOMER NAME :{' '}
          {moduleData.customer_name
            ? moduleData.customer_name
            : moduleData.customer_id?.customer_name}
        </th>
        <th align="left" colSpan={5}>
          DOC. ISSUE NO
        </th>
        <th align="left" colSpan={4}>
          01
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={3}>
          PROD START DATE / TIME :-{' '}
          {isView
            ? formatDate(moduleData?.setups?.[tabValue]?.prod_start_date)
            : moduleData &&
              Array.isArray(moduleData.setups) && (
                <DatePickerMui
                  label=""
                  value={moment(
                    moduleData?.setups?.[tabValue]?.prod_start_date
                  )}
                  onChange={(date) => {
                    moduleData.setups[tabValue].prod_start_date = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
        </th>
        <th align="left" colSpan={1}>
          {isView
            ? convToTime(moduleData?.setups?.[tabValue]?.prod_start_time)
            : moduleData &&
              Array.isArray(moduleData.setups) && (
                <TimePicker
                  label=""
                  value={moment(
                    moduleData?.setups?.[tabValue]?.prod_start_time
                  )}
                  onChange={(date) => {
                    moduleData.setups[tabValue].prod_start_time = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
        </th>
        <th align="left" colSpan={4}>
          PROD END DATE / TIME :-{' '}
          {isView
            ? formatDate(moduleData?.setups?.[tabValue]?.prod_end_date)
            : moduleData &&
              Array.isArray(moduleData.setups) && (
                <DatePickerMui
                  label=""
                  value={moment(moduleData?.setups?.[tabValue]?.prod_end_date)}
                  onChange={(date) => {
                    moduleData.setups[tabValue].prod_end_date = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
        </th>
        <th align="left" colSpan={2}>
          {isView
            ? convToTime(moduleData?.setups?.[tabValue]?.prod_end_time)
            : moduleData &&
              Array.isArray(moduleData.setups) && (
                <TimePicker
                  label=""
                  value={moment(moduleData?.setups?.[tabValue]?.prod_end_time)}
                  onChange={(date) => {
                    moduleData.setups[tabValue].prod_end_time = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
        </th>
        <th align="left" colSpan={5}>
          DOC. ISSUE DATE
        </th>
        <th align="left" colSpan={4}>
          08/10/2017
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={3}>
          PART NUMBER & MODEL :
          {moduleData.part_number
            ? moduleData.part_number
            : moduleData.part_id?.part_number}
        </th>
        <th align="left" colSpan={1}>
          <TableInput
            isView={isView}
            name="model"
            type="text"
            value={moduleData.model}
            onChange={(e) => {
              moduleData.model = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={6} align="left">
          M/C No:
          {isView ? (
            moduleData?.setups[tabValue]?.machine_id?.machine_no
          ) : (
            <AutocompleteMuiCustom
              id="Machine"
              label="Machine"
              option_name="machine_no"
              key={tabValue + 'machine'}
              arrayofObj={machineData}
              value={moduleData?.setups[tabValue]?.machine_id || ''}
              onChange={(e, value) => {
                moduleData.setups[tabValue].machine_id = value;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th align="left" colSpan={9}></th>
      </tr>
      <tr>
        {[
          'S.NO.',
          'INSPECTION PARAMETER',
          'SPECIFICATION',
          'METHOD OF CHECKING',
        ].map((head) => (
          <th rowSpan={3} style={{ textTransform: 'uppercase' }}>
            {head}
          </th>
        ))}
        <th colSpan={6}>FIRST OFF APPROVAL</th>
        <th colSpan={6}>LAST OFF APPROVAL</th>
        <th rowSpan={3}>SCRAP QTY.</th>
        <th rowSpan={3} colSpan={2}>
          REMARKS
        </th>
      </tr>
      <tr>
        <th colSpan={6}>OBSERVATION</th>
        <th colSpan={6}>OBSERVATION</th>
      </tr>
      <tr>
        {moduleData.setups.length > 0 &&
          Array.from({ length: 5 }, () => 0).map((_, index) => (
            <th>{index + 1}</th>
          ))}
        <th>RESULT</th>
        {moduleData.setups.length > 0 &&
          Array.from({ length: 5 }, () => 0).map((_, index) => (
            <th>{index + 1}</th>
          ))}
        <th>RESULT</th>
      </tr>
    </thead>
  );
};

export default THead;
